import React from "react";
import styled from "styled-components";

export default styled.div`
  background-color: ${({ backgroundColor }) => backgroundColor()};
`;



// WEBPACK FOOTER //
// ./src/components/common/Background.js